module.exports = __webpack_public_path__ + "static/media/straven_3.ae8ff69d.jpg";